(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-buybox"]) return;
  try {
    
if (!customElements.get('z-buybox')) {
  customElements.define('z-buybox', class extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
      this.idInput = this.querySelector('[data-variant-id]');
      this.cta = this.querySelector('[data-buybox-cta]');
      this.ctaText = this.querySelector('[data-cta-text]');
      this.optionInputs = Array.from(this.querySelectorAll('[data-option-index]'));
      this.planInputs = Array.from(this.querySelectorAll('input[data-plan]'));
      this.addonInputs = Array.from(this.querySelectorAll('input[data-addon]'));
      this.formEl = this.querySelector('form');
      if (this.formEl && this.addonInputs.length) {
        // Capture phase: runs before <product-form>'s submit handler snapshots
        // FormData. With an addon selected we switch the form to the multi-item
        // items[n][id] shape, then restore after the snapshot is taken.
        this.formEl.addEventListener('submit', () => {
          this.syncAddonItems();
          setTimeout(() => this.clearAddonItems(), 0);
        }, true);
      }
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-index]')) this.onVariantChange();
        if (e.target.matches('input[data-plan]')) this.onPlanChange();
        if (e.target.matches('input[data-addon]') || e.target.matches('input[data-plan]')) this.updateCtaTotal();
      });
      this.currentVariant = this.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value)) || this.variants[0];
      this.updateCtaTotal();
    }
    selectedOptions() {
      const opts = [];
      this.optionInputs.forEach((i) => { if (i.checked) opts[+i.dataset.optionIndex] = i.value; });
      return opts;
    }
    onVariantChange() {
      const sel = this.selectedOptions();
      const match = this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      if (!match) return;
      this.currentVariant = match;
      if (this.idInput) this.idInput.value = match.id;
      // refresh each plan price from this variant's allocations
      this.planInputs.forEach((input) => {
        const planId = input.value;
        let cents = match.price;
        let compare = null;
        if (planId) {
          const alloc = (match.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(planId));
          if (alloc) { cents = alloc.price; compare = alloc.compare_at_price; }
        }
        input.dataset.price = cents;
        const priceEl = input.nextElementSibling && input.nextElementSibling.querySelector('[data-plan-price]');
        if (priceEl) priceEl.innerHTML = '<b>' + this.moneyShort(cents) + '</b>' + (compare && compare > cents ? '<s>' + this.moneyShort(compare) + '</s>' : '');
      });
      // availability
      if (this.cta) {
        this.cta.disabled = !match.available;
        if (this.ctaText) this.ctaText.textContent = match.available ? (this.cta.dataset.label || this.ctaText.textContent) : 'Sold out';
      }
      this.onPlanChange();
      this.updateCtaTotal();
    }
    updateCtaTotal() {
      if (!this.cta || !this.ctaText || this.cta.disabled) return;
      const plan = this.planInputs.find((i) => i.checked);
      const base = plan ? +plan.dataset.price : (this.currentVariant ? this.currentVariant.price : 0);
      const addon = (this.addonInputs || []).find((i) => i.checked && i.value);
      const label = this.cta.dataset.label || 'Add to cart';
      if (!addon) {
        this.ctaText.textContent = base > 0 ? label + ' - ' + this.moneyShort(base) : label;
        return;
      }
      const full = base + +addon.dataset.price;
      let discounted = addon.dataset.bundlePrice ? +addon.dataset.bundlePrice : null;
      const pct = +(this.dataset.addonDiscountPct || 0);
      if (discounted === null && pct > 0) discounted = Math.round(full * (100 - pct) / 100);
      if (discounted !== null && discounted < full) {
        this.ctaText.innerHTML = label + ' - <s>' + this.moneyShort(full) + '</s> ' + this.moneyShort(discounted);
      } else {
        this.ctaText.textContent = label + ' - ' + this.moneyShort(full);
      }
    }
    moneyShort(cents) { return cents % 100 === 0 ? '$' + (cents / 100) : this.money(cents); }
    onPlanChange() { /* selling_plan + id are native form fields; nothing else needed */ }
    syncAddonItems() {
      this.clearAddonItems();
      const sel = this.addonInputs.find((i) => i.checked && i.value);
      if (!sel) return;
      const qtyEl = this.formEl.querySelector('input[name="quantity"]');
      const fields = [
        ['items[0][id]', this.idInput ? this.idInput.value : ''],
        ['items[0][quantity]', qtyEl ? qtyEl.value : 1],
        ['items[1][id]', sel.value],
        ['items[1][quantity]', 1],
      ];
      this._addonEls = fields.map(([name, value]) => {
        const el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        el.value = value;
        this.formEl.appendChild(el);
        return el;
      });
      this._addonDisabled = [this.idInput, qtyEl].filter(Boolean);
      this._addonDisabled.forEach((el) => { el.disabled = true; });
    }
    clearAddonItems() {
      (this._addonEls || []).forEach((el) => el.remove());
      this._addonEls = [];
      (this._addonDisabled || []).forEach((el) => { el.disabled = false; });
      this._addonDisabled = [];
    }
    money(cents) { return '$' + (cents / 100).toFixed(2); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-promo-bar"]) return;
  try {
    
if (!customElements.get('z-countdown')) {
  customElements.define('z-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = new Date(this.getAttribute('deadline')).getTime();
      if (isNaN(this.deadline)) return;
      this.els = {
        d: this.querySelector('[data-days]'), h: this.querySelector('[data-hours]'),
        m: this.querySelector('[data-mins]'), s: this.querySelector('[data-secs]')
      };
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      let diff = this.deadline - Date.now();
      if (diff <= 0) {
        diff = 0; clearInterval(this.timer);
        if (this.hasAttribute('hide-expired')) { const bar = this.closest('.z-promo'); if (bar) bar.hidden = true; }
      }
      const pad = (n) => String(n).padStart(2, '0');
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (this.els.d) this.els.d.textContent = pad(d);
      if (this.els.h) this.els.h.textContent = pad(h);
      if (this.els.m) this.els.m.textContent = pad(m);
      if (this.els.s) this.els.s.textContent = pad(s);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-sticky-cta"]) return;
  try {
    
if (!customElements.get('z-sticky-cta')) {
  customElements.define('z-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-bar]');
      this.sentinel = this.querySelector('[data-sentinel]');
      const id = this.dataset.hideTarget;
      this.target = id ? document.getElementById(id) : null;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.update(); this.ticking = false; });
      };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
    }
    inView(el) { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; }
    update() {
      if (!this.bar || !this.sentinel) return;
      const past = this.sentinel.getBoundingClientRect().top < 0;
      const suppress = this.target ? this.inView(this.target) : false;
      this.bar.classList.toggle('is-visible', past && !suppress);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-tabs"]) return;
  try {
    
if (!customElements.get('z-tabs')) {
  customElements.define('z-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
    }
    select(i) {
      this.tabs.forEach((tab, j) => {
        const active = i === j;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (this.panels[j]) this.panels[j].hidden = !active;
      });
    }
    onKey(e, i) {
      const last = this.tabs.length - 1;
      let n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = i === 0 ? last : i - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = last;
      if (n !== null) { e.preventDefault(); this.select(n); this.tabs[n].focus(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-testimonials"]) return;
  try {
    
if (!customElements.get('z-carousel')) {
  customElements.define('z-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const root = this.closest('.z-testimonials') || document;
      this.prev = root.querySelector('[data-prev]');
      this.next = root.querySelector('[data-next]');
      if (!this.track) return;
      const step = () => Math.max(this.track.clientWidth * 0.8, 260);
      if (this.prev) this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }
    updateButtons() {
      const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-ugc-carousel"]) return;
  try {
    
if (!customElements.get('z-ugc')) {
  customElements.define('z-ugc', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.parentElement.querySelector('[data-prev]');
      this.next = this.parentElement.querySelector('[data-next]');
      if (this.track) {
        const step = () => Math.max(this.track.clientWidth * 0.8, 240);
        if (this.prev) this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (this.next) this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.updateButtons();
      }
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-play]');
        if (btn) {
          const video = btn.parentElement.querySelector('video');
          if (video) { video.play(); btn.hidden = true; }
          return;
        }
        const vid = e.target.closest('video');
        if (vid && !vid.paused) vid.pause();
      });
      // media events don't bubble, but they do capture
      this.addEventListener('pause', (e) => {
        const media = e.target.closest && e.target.closest('.z-ugc__media');
        const btn = media && media.querySelector('[data-play]');
        if (btn) btn.hidden = false;
      }, true);
    }
    updateButtons() {
      if (!this.track) return;
      const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
